import { render, staticRenderFns } from "./SpotItems.vue?vue&type=template&id=22b00779"
import script from "./SpotItems.vue?vue&type=script&lang=js"
export * from "./SpotItems.vue?vue&type=script&lang=js"
import style0 from "./SpotItems.vue?vue&type=style&index=0&id=22b00779&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports